import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const Preview = styled.img`
  height: 100px;
  width: 100px;
  object-fit: cover;
`;

export interface ImagePreviewProps {
  file: File;
}
export const ImagePreview: React.FC<ImagePreviewProps> = (
  props: ImagePreviewProps,
) => {
  const [reader] = useState(new FileReader());
  const { file } = props;
  const ref = useRef<HTMLImageElement | null>(null);
  useEffect(() => {
    function onLoad() {
      if (ref.current) {
        ref.current.src = reader.result as string;
      }
    }
    reader.addEventListener('load', onLoad);
    reader.readAsDataURL(file);
    return () => {
      reader.abort();
      reader.removeEventListener('load', onLoad);
    };
  }, [reader, file]);

  return <Preview ref={ref} />;
};
